<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <h1 class="page-title">Dashboard</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current" >Administration Board</span>
        </div>
    </div>

    <hr class="mb-4" />

    <div class="d-flex align-items-center justify-content-center text-center" style="height: 60vh">
        <div>
            <h1 class="display-4 fw-bold">Under Construction</h1>
            <p class="lead mb-4">We're working hard to bring something great. Check back soon!</p>
        </div>

    </div>
</div>
